import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Flex} from '@travel-frontend/ui-components';

import {Button} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Hero/components/Button';

export const Content = styled(Flex)(
  ({theme}) => css`
    padding: 16px;
    /* Custom colours */
    background: linear-gradient(180deg, #2986f2 28.15%, #002873 100%);
    min-width: auto;

    ${theme.respondTo(
      'sm',
      css`
        min-width: 219px;
        padding: 8px 12px;
        ${Button} {
          padding: 8px 16px;
        }
      `
    )};

    ${theme.respondTo(
      'md',
      css`
        max-width: 250px;
        padding: 8px 24px;
      `
    )};

    ${theme.respondTo(
      'lg',
      css`
        min-width: 300px;
        padding: 8px 80px 8px 24px;
      `
    )};
  `
);
